import { Injectable } from '@angular/core';
import { ADMIN_ROUTE_CONSTANTS } from '@shared/constants/routes/admin-routes.constants';
import {MenuItem} from 'primeng/api';

@Injectable({ providedIn: 'root' })
export class MenuUserService {
  buildMenu(): MenuItem[] {
    const adminBase = `/${ADMIN_ROUTE_CONSTANTS.path}`;

    const dashboard: MenuItem = {
      label: 'MENU.DASHBOARD',
      icon: ADMIN_ROUTE_CONSTANTS.dashboard.data.icon,
      hasSubmenu: false,
      routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.dashboard.path}`
    };

    const myUnit: MenuItem = {
      label: 'MENU.USER.MY_UNIT',
      icon: 'pi pi-home',
      hasSubmenu: false,
      routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.inDevelop.path}`
    };

    const communityChildren: MenuItem[] = [
      {
        label: 'MENU.USER.COMMUNITY_SUB.COMMUNICATIONS',
        icon: 'pi pi-comments',
        routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.inDevelop.path}`
      },
      {
        label: 'MENU.USER.COMMUNITY_SUB.EVENTS',
        icon: 'pi pi-calendar',
        routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.operations.path}/${ADMIN_ROUTE_CONSTANTS.operations.reservations.path}`
      },
      {
        label: 'MENU.USER.COMMUNITY_SUB.COMMON_AREAS',
        icon: 'pi pi-map',
        routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.community.path}/${ADMIN_ROUTE_CONSTANTS.community.commonAreas.path}`
      }
    ];

    const community: MenuItem = {
      label: 'MENU.USER.COMMUNITY',
      icon: 'pi pi-users',
      hasSubmenu: true,
      expanded: false,
      items: communityChildren
    };

    const paymentsChildren: MenuItem[] = [
      {
        label: 'MENU.USER.PAYMENTS_SUB.VIEW_BILLS',
        icon: 'pi pi-file-invoice',
        routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.inDevelop.path}`
      },
      {
        label: 'MENU.USER.PAYMENTS_SUB.PAYMENT_HISTORY',
        icon: 'pi pi-history',
        routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.inDevelop.path}`
      },
      {
        label: 'MENU.USER.PAYMENTS_SUB.MAKE_PAYMENT',
        icon: 'pi pi-credit-card',
        routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.inDevelop.path}`
      }
    ];

    const payments: MenuItem = {
      label: 'MENU.USER.PAYMENTS',
      icon: 'pi pi-dollar',
      hasSubmenu: true,
      expanded: false,
      items: paymentsChildren
    };

    const servicesChildren: MenuItem[] = [
      {
        label: 'MENU.USER.SERVICES_SUB.MAINTENANCE_REQUESTS',
        icon: 'pi pi-wrench',
        routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.inDevelop.path}`
      },
      {
        label: 'MENU.USER.SERVICES_SUB.VISIT_AUTHORIZATION',
        icon: 'pi pi-shield',
        routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.inDevelop.path}`
      },
      {
        label: 'MENU.USER.SERVICES_SUB.MOVING_REQUESTS',
        icon: 'pi pi-truck',
        routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.inDevelop.path}`
      }
    ];

    const services: MenuItem = {
      label: 'MENU.USER.SERVICES',
      icon: 'pi pi-cog',
      hasSubmenu: true,
      expanded: false,
      items: servicesChildren
    };

    const profile: MenuItem = {
      label: 'MENU.USER.PROFILE',
      icon: 'pi pi-user',
      hasSubmenu: false,
      routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.profile.path}`
    };

    return [
      dashboard,
      myUnit,
      community,
      payments,
      services,
      profile
    ];
  }
}
